import styles from './Task.module.scss'
import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger)

interface IssueList {
  title: string
  subTitle: JSX.Element
  text: string
}

interface SolutionList {
  h4Text: string
  h3Text: string
  text: string
}

const issueLists: IssueList[] = [
  {
    title: 'CONSISTENCY',
    subTitle: (
      <p className={styles.task_title}>
        一貫性が
        <br />
        担保されていない...
      </p>
    ),
    text: '度重なる機能追加・改修で、デザインの一貫性が失われている。例えば、似たようなボタンがたくさん存在している。',
  },
  {
    title: 'UNIFICATION',
    subTitle: (
      <p className={styles.task_title}>
        プロダクト全体の
        <br />
        統一感がない...
      </p>
    ),
    text: 'メインのデザイナーが変わったり、サービス毎に異なるトンマナが適用されていて、複数プロダクトの関連性が希薄。',
  },
  {
    title: 'EFFICIENCY',
    subTitle: (
      <p className={styles.task_title}>
        実装に手間が掛かり
        <br />
        改善が進まない...
      </p>
    ),
    text: 'サービスの仕様変更時にデザインと実装の修正に、時間と手間がかかり困っている。',
  },
]

const solutionLists: SolutionList[] = [
  {
    h4Text: '一貫性が担保されていない...',
    h3Text: 'デザインを整理・パターン化',
    text: '画面遷移、レイアウト、UI部品のデザインや挙動などを整理・パターン化しアプリに反映させることで、操作性や見た目が一貫したものになり一貫したUXが実現できます。',
  },
  {
    h4Text: 'プロダクト全体の統一感がない...',
    h3Text: 'ブランド定義から丁寧に',
    text: 'Aitriaのデザインシステム制作はプロダクトにおけるブランドのあり方から定義します。はじめにきちんと言語化し、ブランドにしっかりと結びついたビジュアル表現を再定義することで、ブレなくプロダクトの一貫したブランドを高めることができます。',
  },
  {
    h4Text: '実装に手間が掛かり、改善が進まない...',
    h3Text: '再利用しやすい設計',
    text: '一度デザイン・実装したものは再利用できる形にすることで、運用での作業工数を減らすことができます。',
  },
]

const Task = () => {
  const slide = useRef<HTMLDivElement>()
  const section = useRef<HTMLElement>()
  const slides = useRef<HTMLUListElement>()
  useEffect(() => {
    gsap.to(slide.current, {
      width: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: section.current,
        start: 'top-=350 top+=200',
      },
    })
    Array.prototype.forEach.call(slides.current.children, (element: HTMLElement) => {
      gsap.to(element.children[0].children[0].children[0], {
        width: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: element.children[0],
          start: 'top-=350 top+=200',
        },
      })
    })
  }, [])

  const issueList = issueLists.map(({ title, subTitle, text }, index) => (
    <li key={title}>
      <img src="/images/LP/designsystem/taskIcon.svg" alt={`0${index}${title}`} />
      <h4>
        0{index + 1} {title}
      </h4>
      {subTitle}
      <p className={styles.text}>{text}</p>
    </li>
  ))

  const solutionList = solutionLists.map(({ h4Text, h3Text, text }, index) => (
    <li key={index}>
      <div className={styles.text_wrapper}>
        <div className={styles.title_wrapper}>
          <div className={styles.slider}></div>
          <span>CASE 0{index + 1}</span>
          <h4>{h4Text}</h4>
          <h3>{h3Text}</h3>
        </div>
        <p>{text}</p>
      </div>
      <div className={styles.img_wrapper}>
        <img src={`/images/LP/designsystem/case${index + 1}.png`} alt={`CASE 0${index + 1}`} />
      </div>
    </li>
  ))

  return (
    <section className={styles.section} ref={section}>
      <div className={styles.black}>
        <div className={styles.title}>
          <div className={styles.slider} ref={slide}></div>
          <span>Design issues</span>
          <h2>よくあるデザインの課題</h2>
        </div>
        <ul>{issueList}</ul>
        <div className={styles.arrow}>
          <img src="/images/LP/designsystem/arrowToBottom.svg" alt="" />
        </div>
      </div>
      <div className={styles.solution}>
        <div className={styles.title}>
          <span className={styles.en}>Solution</span>
          <h3>
            このような課題を
            <br />
            デザインシステムを用いて
            <span>解決します</span>
          </h3>
        </div>
        <ul ref={slides}>{solutionList}</ul>
      </div>
    </section>
  )
}

export default Task
